<template>
  <div class="audio-replay">
    <header class="panel-header">
      <div class="panel-left-item">
        <button class="text-button narrow-button" @click="close" v-t>Back</button>
      </div>
      <div class="panel-title" v-t>Sounds good?</div>
      <div class="panel-right-item">
        <button class="flat-button narrow-button" @click="done" v-t>Save</button>
      </div>
    </header>
    <audio-player :src="src" />
    <footer class="panel-footer">
      <div v-t>Title</div>
      <div class="audio-replay-title-form">
        <input
          ref="titleInput"
          v-model="title"
          type="text"
          @keyup.enter="done"
          v-t:placeholder="'Enter a title for your recording'"
        />
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import t from 'vuedirectives/t'
import AudioPlayer from 'vuecomponents/audio_player'
import { mapState } from 'vuex'

export default {
  components: { AudioPlayer },
  directives: { t },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['isMobile']),
  },
  data() {
    return {
      title: '',
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.$refs.titleInput.focus()
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    done() {
      this.$emit('done', this.title)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.audio-replay {
  footer {
    padding: 0px 16px;
    font-size: $big-body-font-size;
    font-weight: 500;
    justify-content: flex-start;

    .audio-replay-title-form {
      flex-grow: 1;
    }

    input {
      margin-left: 16px;
      border-bottom: none;
      margin-bottom: 0;
      box-shadow: none;
      width: 100%;
      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
